<div class="loginwrapper">
  <div class="lg-inner-column">
    <div class="right-column relative">
      <div class="inner-content h-full flex flex-col bg-white dark:bg-slate-800">
        <div class="auth-box h-full flex flex-col justify-center">
          <div class="mobile-logo text-center mb-6  block">
            <a [routerLink]="['/']">
              <img src="assets/images/2023/logo-mobile.png" alt="" class="mb-10 dark_logo inline-block">
              <img src="assets/images/2023/logo-mobile-white.png" alt="" class="mb-10 white_logo inline-block">
            </a>
          </div>
          <auth-formlogin *ngIf="path == 'auth/login' || path == 'connexion'"></auth-formlogin>
          <auth-formpassword *ngIf="path == 'auth/resetpassword'"></auth-formpassword>
          <auth-formsignin *ngIf="path == 'auth/signin'"></auth-formsignin>
          <auth-formverify *ngIf="path == 'auth/authverify'"></auth-formverify>
        </div>
        <div class="auth-footer text-center">
          Copyright 2023, Cllaj-Martinique All Rights Reserved.
        </div>
      </div>
    </div>
    <div class="left-column bg-contain bg-no-repeat bg-center " style="background-image: url(assets/images/Connexion-jeune_tel+ordi.png); background-color: white;">
      <div class="flex flex-col h-full justify-center">
        <div class="flex-1 flex flex-col justify-center items-center">
        </div>
        <div class="subtitle-wrapper">
          <div class="black-500-title max-w-[525px] mx-auto pb-20 text-center">
            <span style="color: #fe6323;">avec le CLLAJ </span><span style="color: #1f519e;">c'est + facile !</span>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
